export default __webpack_public_path__ + "11f19612eb50ca7aef8fdf447942e524.svg";